<template>
	<div class="header contentBlock fontLarge">
		<div :class="['logo', { paddingTop: !signingSuccess }]">
			<img :src="logoUrl" alt="Leland Little Logo" />
		</div>

		<div :class="[signingSuccess ? 'titleSigned' : 'title', 'textRight']">
			<span class="colorGrey centerWhenMobile">
				<template v-if="!isStaff && signedByCustomer">
					Consigned Property for Contract #{{ contract.contract_id }}
				</template>

				<template v-else>
					<a v-if="isStaff" :href="`/lladmin/?menuitem=contracts&sortby=created_date&sort=desc`" class="colorGrey"
						tabindex="-1">
						Consignment Contract #{{ contract.contract_id }}
					</a>
					<span v-else> Consignment Contract #{{ contract.contract_id }} </span>
				</template>
			</span>
		</div>

		<div v-if="linkSent" class="successMessage contentBlock marginBottom paddingBottom textCenter paddingTop">
			Successfully sent email containing signature request link to customer's
			email on file.
		</div>

		<div v-if="errorMessages.length" class="errorMessage contentBlock marginBottom paddingBottom">
			<div v-for="(error, index) in errorMessages" :key="index">
				{{ error }}<br />
			</div>
		</div>
	</div>
</template>

<script>
import contractState from "../../../mixins/contractState";

export default {
	name: "Header",
	mixins: [contractState],
	props: {
		contract: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style scoped></style>
